<template>
  <div>
    <div class="notification-header">
      <span class="notification-title">MESSAGES</span>
      <div class="notifications-number" v-if="numberOfMessages > 0">
        {{ numberOfMessages }}
      </div>
    </div>
    <ChatItemListDropdown
      v-for="msg in messages"
      :key="msg.id"
      :message="msg"
      @button="setChat(msg)"
    />
    <span class="no-message" v-if="messages.length === 0">No new messages</span>
    <div class="more-messages">
      <router-link
        id="message-link"
        to="/s-app/message-center"
        v-if="extraMessages > 0"
        >{{ extraMessages }} more message ></router-link
      >
      <router-link id="message-link" to="/s-app/message-center" v-else
        >View all messages ></router-link
      >
    </div>
  </div>
</template>

<script>
import ChatItemListDropdown from "@/material-components/molecules/ChatItemListDropdown.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
export default {
  name: "SHeaderMessagesDropdown",
  props: ["messages", "extraMessages", "numberOfMessages"],
  mixins: [ChatHelperVue],
  components: {
    ChatItemListDropdown,
  },
  methods: {
    setChat(msg) {
      let type = "";
      if (msg.type === "USERS_ITEM_MESSAGE" || msg.type === "MY_ITEM_MESSAGE") {
        type = "item";
      } else if (
        msg.type === "MY_MODERATOR_GROUP_MESSAGE" ||
        msg.type === "MY_GROUP_MESSAGE"
      ) {
        type = "group";
      }

      if(this.$router.history.current.fullPath === "/s-app/message-center"){
        this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.routerView.getChat(msg.key.id, msg.messages[msg.messages.length - 1].id, type);
      }else{
          this.$router.push({
          path: "/s-app/message-center",
          query: {
            chat: msg.key.id,
            type: type,
            id: msg.messages[msg.messages.length - 1].id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-header {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  border-bottom: solid;
  border-color: $primary;
}
.notification-title {
  font-size: 1.2rem !important;
  font-weight: bold;
  padding-left: 10px;
}
.more-messages {
  text-align: center;
  margin-bottom: 0.5rem;
}
#message-link:active {
  background-color: transparent;
}
</style>
